<template>
  <transition name="fade">
    <div class="light-video-area" id="lightVideoArea" v-show="lgVideoShow">
      <div class="light-video-wrap">
        <div class="light-video-close">
          <div class="icon" id="lightVideoClose" @click="closeVideo">
            <!-- @click="lgVideoShow = !lgVideoShow" -->
            <img src="@/assets/img/icon_m_close.svg" alt="" />
          </div>
        </div>
        <div class="light-video-box" id="lightVideoBox">
          <!-- <video class="video-js vjs-theme-forest video-banner" id="lgVideo">
            controls="controls"
            preload="auto"
            poster="@/assets/img/video_default.png"
            data-setup="{}"
            <source :src="videoSrc" :type="videoType" />
            <source src="@/assets/video/adv.mp4" type="video/mp4" />
            <source src="video/adv.mp4" type="video/mp4"/>
            <source src="video/adv.webm" type="video/webm"/>
            <p class="vjs-no-js">
              To view this video please enable JavaScript, and consider
              upgrading to a web browser that<a
                href="https://videojs.com/html5-video-support/"
                target="_blank"
                >supports HTML5 video</a
              >
            </p>
          </video> -->
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "videoLightBox",
  // props: ["show", "videoLink"],
  data() {
    return {
      lgVideoShow: false,
      videoSrc:
        "https://streamipcfapp.akamaized.net/live/_definst_/smil:liveabr.smil/playlist.m3u8",
      // videoSrc: "https://youtu.be/87OMBCgaZDk",
      // videoSrc: "",
      // videoType: "application/x-mpegURL",//要對應影片的格式，這個是live m3u8用
      // videoType: "video/webm",
      // videoTyps: "video/mp4",
      videoType: "application/x-mpegURL",
      originType: "",
      videoSty: "",
    };
  },
  mounted() {
    //== 設置videojs ==
    // window.videojs("lgVideo", {
    //   controls: true,
    //   autoplay: false,
    //   preload: "auto",
    //   poster: require("@/assets/img/video_default.png"),
    // });
    //=== 接收影片打開 ===

    this.$bus.$on("swOpenVideo", (data) => {
      //有開起來就先關掉
      if( this.lgVideoShow){
        this.closeVideo();
      }
      this.lgVideoShow = true;
      // this.videoSrc = data;

      //**判斷取得的是影片還是廣播，給予不同樣式，廣播只會有控制bar
      this.videoSrc = data.videoLink;
      this.originType = data.swType;
      console.log("videoType是：", this.originType);
      if (this.originType === "program") {
        this.videoSty = "video-banner";
        console.log("this.videoSty", this.videoSty);
      } else {
        this.videoSty = "radio-banner";
        console.log("this.videoSty", this.videoSty);
      }

      // this.videoSrc = require("@/assets/video/adv.mp4");
      // this.videoType = "video/mp4";//要注意影片內容Type
      //== 關閉時 dispose 是移除整個dom元件 所以打開時要再加入dom 在宣告使用 ==
      //data-setup=\'{ "techOrder": ["youtube"], "sources": [{ "type": "video/youtube", "src": "' +this.videoSrc +'"}],"youtube": { "ytControls": 1 ,"autoplay": 1 }}\'>'
      var liveVideo =
        '<video autoplay webkit-playsinline playsinline class="video-js vjs-theme-forest ' +
        this.videoSty +
        ' " id="lgVideo" data-setup={}>' +
        '<source src="' +
        this.videoSrc+"?playsinline=1" +
        '" type="' +
        this.videoType +
        '" />' +
        '<p class="vjs-no-js"> To view this video please enable JavaScript, and consider upgrading to a web browser that' +
        '<a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>' +
        "</p></video>";
      this.$("#lightVideoBox").append(liveVideo);
      //== 設置videojs ==
      window.videojs("lgVideo", {
        controls: true, //如果自動播放，就不用 true , false 就好
        autoplay: true, //點擊後直接播放 false
        // preload: "auto",
        // poster: require("@/assets/img/video_default.png"),
      });

      //== 改變影片網址 == * 如果是是直接更換可以這樣直接更換
      //window.videojs("lgVideo").src({ type: this.videoType, src: this.videoSrc });

      //   var delId = this.list.findIndex((item) => {
      //     return item.subcategory_id == data; // 0
      //   });
      //   this.list.splice(delId, 1);
    });
  },
  methods: {
    //=== 關閉lightbox ===
    closeVideo() {
      console.log("自己關關");
      this.lgVideoShow = false;
      //== 關閉的時候也要取消video，dispose 是移除整個dom元件 所以打開時要再加入dom==
      window.videojs("lgVideo").dispose();
      // this.$bus.$emit("closeVideo", "close");
    },
  },
  beforeDestroy() {
    console.log("離開lightbox");
    // window.videojs("lgVideo").dispose();
    //==== 元件銷毀前要取消監聽 ====
    this.$bus.$off("swOpenVideo");
    // this.$bus.$off("closeVideo");
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
